import { addMonths, isPast } from 'date-fns'

//
export const CertificateGracePeriod = {
  ADVANCED_TRAINER_EVERYDAY_OBJECTS_AND_GROUND_ASSAULTS: 1,
  ADVANCED_TRAINER_GROUND_SUPPORT_AND_RESPONSE_TO_DEAD_WEIGHT: 1,
  ADVANCED_TRAINER_GROUND_SUPPORT: 1,
  ADVANCED_TRAINER_OBJECTS_USED_AS_WEAPONS: 1,
  ADVANCED_TRAINER: 1,
  FOUNDATION_TRAINER_PLUS: 3,
  INTERMEDIATE_TRAINER: 3,
}

export function isCertificateOutsideGracePeriod(
  certificateExpiryDate: string,
  courseLevel: string,
): boolean {
  const expiryDate = new Date(certificateExpiryDate)
  return isPast(
    addMonths(
      expiryDate,
      CertificateGracePeriod[
        courseLevel as keyof typeof CertificateGracePeriod
      ] ?? 0,
    ),
  )
}

export const isValidCertificate = (certificate: {
  expiryDate: string
  courseLevel: string
}) => {
  return (
    !isPast(new Date(certificate.expiryDate)) ||
    !isCertificateOutsideGracePeriod(
      certificate.expiryDate,
      certificate.courseLevel,
    )
  )
}
